










































export default
  props: {
    level:
      type: String
      default: '初級！'
    position:
      type: Number
      default: 0
    point:
      type: Number
      default: 0
  }

  data: () ->
    spShowMenu: false

  methods: {
    show_sppoint: () ->
      @spShowMenu = !@spShowMenu
  }
